import {AfterViewInit, Component, HostListener, OnInit} from '@angular/core';
import {DatePipe} from '@angular/common';
import {AmenitiesService} from '../../../services/amenities.service';
import {ApiClientService} from '../../../services/api-client.service';
import { AuthenticationService } from '../../../services/authentication.service';
import {MaintenanceCalendarService} from 'app/services/maintenance-calendar.service';

declare const $: any;
declare const moment: any;
declare const toastr: any;

@Component({
    selector: 'maintenance-calendar-calendar-view',
    templateUrl: './maintenance-calendar-calendar-view.component.html'
})
export class MaintenanceCalendarCalendarViewComponent implements OnInit, AfterViewInit {
    calendarOptions: any;
    constructor(public maintenanceCalendarService: MaintenanceCalendarService,
                public api: ApiClientService,
                private authenticationService: AuthenticationService
    ) {}
    ngOnInit() {
        const that = this;
        this.calendarOptions = {
            editable: false,
            displayEventEnd: true,
            eventLimit: true,
            timeFormat: 'h:mma',
            displayEventTime: true,
            showNonCurrentDates: false,
            fixedWeekCount: false,
            header: {
                left: 'title prev,next',
                center: '',
                right: ''
            },
            events: this.maintenanceCalendarService.eventsForCalendar,
            eventRender: (event, model: any) => {
                if (model[0].childNodes[0].childNodes && model[0].childNodes[0].childNodes.length > 2) {
                    const tempSaver = model[0].childNodes[0].childNodes[0].outerHTML;
                    model[0].childNodes[0].childNodes[0].outerHTML = model[0].childNodes[0].childNodes[2].outerHTML;
                    model[0].childNodes[0].childNodes[2].outerHTML = tempSaver;
                }
                model[0].childNodes[0].innerHTML = '<div style="padding-top: 2px;"><i class="fa fa-user fa-2x" aria-hidden="true"></i></div><div class="event-info"">' + model[0].childNodes[0].innerHTML + '</div>';
                let start;
                let end;
                const timezoneOffset = new Date().getTimezoneOffset() / 60;
                if (event.start)
                    start = moment(event.start._d).add(timezoneOffset, 'hours').format('MMM D');
                if (event.end)
                    end = moment(event.end._d).add(timezoneOffset, 'hours').format('MMM D');
                if (model[0].childNodes[0].innerHTML.indexOf('fc-time') == -1) {
                    model[0].childNodes[0].childNodes[1].innerHTML += `<span class="fc-time">${start} ${end ? ('- ' + end) : ''}</span>`;
                }
                if (event.end && event.start && Math.abs(new Date(event.end._i).getTime() - new Date(event.start._i).getTime()) > 86399000) {
                    model[0].childNodes[0].childNodes[1].childNodes[2].innerHTML = `${start} - ${end}`;
                }
                if(!this.authenticationService.userIsResident && !event.disabledDate && event.booking) {
                    let dropdownItems = '';
                    if (event.booking.isCanApprove && !(new Date(event.booking.dateTo) <= new Date()) &&
                        (event.booking.status == 'pending' || event.booking.status == 'declined') && that.allPaymentArePaid(event.booking)) {
                        dropdownItems += '<li class="calendar-dropdown-item">' +
                                         '    Approve' +
                                         '</li>';
                    }
                    if (event.booking.isCanApprove && !(new Date(event.booking.dateTo) <= new Date()) &&
                        (event.booking.status == 'approved' || event.booking.status == 'pending')) {
                        dropdownItems += '<li class="calendar-dropdown-item">' +
                                         '    Decline' +
                                         '</li>';
                    }
                    if (event.booking.isCanEdit && !(new Date(event.booking.dateTo) <= new Date()) &&
                        (event.booking.status == 'pending' || event.booking.status == 'declined')) {
                        dropdownItems += '<li class="calendar-dropdown-item">' +
                                         '    Edit' +
                                         '</li>';
                    }
                    if (event.booking.isCanDelete && !(new Date(event.booking.dateTo) <= new Date())) {
                        dropdownItems += '<li class="calendar-dropdown-item">' +
                                         '    Delete' +
                                         '</li>';
                    }
                    if (event.booking.isCanEdit && that.bookingHasPayments(event.booking)) {
                        dropdownItems += '<li class="calendar-dropdown-item">' +
                                         '    Pay' +
                                         '</li>';
                    }
                    if (dropdownItems) {
                        const div = document.createElement('div');
                        div.classList.add('dropdown-button-wrapper');
                        model[0].childNodes[0].appendChild(div);
                        model[0].childNodes[0].childNodes[2].innerHTML = '<button data-toggle="dropdown" class="btn btn-white dropdown-toggle btn-xs" aria-expanded="false" style="background: transparent; border: none;">' +
                                                                         '   <i class="fa fa-chevron-down"></i>' +
                                                                         '</button>';

                        model[0].childNodes[0].childNodes[2].innerHTML += '<ul class="dropdown-menu pull-right">' + dropdownItems + '</ul>';
                    }
                }
            },
            dayRender: function(date, cell: any) {
                if(cell[0].classList.value.indexOf('fc-disabled-day') == -1 && new Date(moment(date).format('YYYY/MM/DD')) >= new Date(moment(new Date()).format('YYYY/MM/DD')))
                    cell[0].innerHTML = '<div class="plus-wrapper"><i class="fa fa-2x fa-plus-circle"></i></div>';
            },
            dayClick: (date, jsEvent, view) => {
                if(!this.maintenanceCalendarService.calendarSpinnerShow && jsEvent.target.classList.value == 'fa fa-2x fa-plus-circle') {
                    this.maintenanceCalendarService.isAmenityModalShow = true;
                    this.maintenanceCalendarService.prefilledDateFromCaledar = moment(date).format('DD.MM.YYYY');
                }
            },
            eventClick: (event, clickTarget) => {
                if(!event.disabledDate) {
                    if (clickTarget.target.className.indexOf('fa-chevron-down') == -1 &&
                        clickTarget.target.className.indexOf('dropdown-toggle') == -1 &&
                        clickTarget.target.className.indexOf('calendar-dropdown-item') == -1)
                        this.openViewAmenityModal(event);
                    else if (!this.authenticationService.userIsResident) {
                        if (clickTarget.target.closest('.fc-content').classList.contains('increase-z-index')) {
                            clickTarget.target.closest('.fc-content').classList.remove('increase-z-index');
                            clickTarget.target.closest('.fc-widget-content').classList.remove('increase-z-index');
                        } else {
                            clickTarget.target.closest('.fc-content').classList.add('increase-z-index');
                            clickTarget.target.closest('.fc-widget-content').classList.add('increase-z-index');
                            // removing the previously added class in case calendar was scrolled.
                            clickTarget.target.closest('.dropdown-toggle').nextElementSibling.parentElement.classList.remove('dropup');
                            if (window.innerHeight - clickTarget.clientY < 105)
                                clickTarget.target.closest('.dropdown-toggle').nextElementSibling.parentElement.classList.add('dropup');
                        }

                        if (clickTarget.target.innerText == 'Approve')
                            this.approveBooking(event.booking);
                        else if (clickTarget.target.innerText == 'Decline')
                            this.declineBooking(event.booking);
                        else if (clickTarget.target.innerText == 'Edit')
                            this.maintenanceCalendarService.editAmenity(event.booking);
                        else if (clickTarget.target.innerText == 'Delete')
                            this.maintenanceCalendarService.deleteAmenity(event.booking.id);
                        else if (clickTarget.target.innerText == 'Pay')
                            this.maintenanceCalendarService.showPaymentModal(event.booking);
                    }
                }
            },
            viewRender: () => {
                if(this.authenticationService.userIsResident)
                    this.maintenanceCalendarService.getAmenitiesForCalendarResident();
                else
                    this.maintenanceCalendarService.getAmenitiesForCalendar();
            }
        };
        $(document).on('click', '.fc-button-group', function() { that.clickButton(); });
        setTimeout(() => $('#ucCalendar').fullCalendar(this.calendarOptions), 500);
    }

    clickButton() {
        if(document.getElementsByClassName('fc-view-container').length < 2) {
            this.modifyCalendarDesign();
            this.authenticationService.userIsResident ? this.maintenanceCalendarService.getAmenitiesForCalendarResident() : this.maintenanceCalendarService.getAmenitiesForCalendar();
        }
    }

    ngAfterViewInit() {
        setTimeout(() => { this.modifyCalendarDesign(); }, 500);
    }

    modifyCalendarDesign(): void {
        for(let i = 0; i < document.getElementsByClassName('fc-day-header').length; i++)
            (<any>document.getElementsByClassName('fc-day-header')[i]).innerText = (<any>document.getElementsByClassName('fc-day-header')[i]).innerText.toUpperCase();
    }

    openViewAmenityModal(booking): void {
        if(booking.currentUserBooking === 1 || !this.authenticationService.userIsResident) {
            this.maintenanceCalendarService.calendarSpinnerShow = true;
        const url = `/v1/booking/${booking.id}.json?expand=amenity,building,suite,resident,createdBy,notes,payments`;
        this.api.get('domainAmenities', url).subscribe((res) => {
            let parsedBooking = [];
            this.maintenanceCalendarService.bookingsFactory([JSON.parse(res._body)], parsedBooking);
            this.maintenanceCalendarService.amenityInAmenityModal = parsedBooking[0];
            this.maintenanceCalendarService.calendarSpinnerShow = false;
            this.maintenanceCalendarService.isAmenityViewShow = true;
        });

        }

    }

    approveBooking(item): void {
        if(this.allPaymentArePaid(item)) {
            let transitionStatus = '';
            if (item.status == 'pending')
                transitionStatus = 'approved';
            else if (item.status == 'declined')
                transitionStatus = 'declined_approved';
            const url = `/v1/booking/transit/${item.id}.json`;
            this.maintenanceCalendarService.api.patch('domainAmenities', url, {transition: transitionStatus}).subscribe(
                () => this.updateView('Status was successfully updated'),
                error => this.api.errorHandler(error, 'Status update failed!')
            );
        } else
            toastr.warning('All payments must be paid before you can confirm the booking.');
    }

    declineBooking(item): void {
        let transitionStatus = '';
        if(item.status == 'pending')
            transitionStatus = 'declined';
        else if(item.status == 'approved')
            transitionStatus = 'approved_declined';
        const url = `/v1/booking/transit/${item.id}.json`;
        this.maintenanceCalendarService.api.patch('domainAmenities', url, {transition: transitionStatus}).subscribe(
            () => this.updateView('Status was successfully updated'),
            error => this.api.errorHandler(error, 'Status update failed!')
        );
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.maintenanceCalendarService.getData();
    }

    allPaymentArePaid(item): boolean {
        let allPaid = true;
        if(item.payments && item.payments.length > 0) {
            item.payments.filter((payment) => {
                if(payment.chosen && !payment.status)
                    allPaid = false;
            });
        }
        return allPaid;
    }

    bookingHasPayments(item): boolean {
        let allPaid = true;
        if(!item.payments || item.payments.length < 1)
            allPaid = false;
        return allPaid;
    }

    @HostListener('document:click', ['$event', '$event.target'])
    public onClick(event: MouseEvent, targetElement: HTMLElement): void {
        if (!targetElement || !targetElement.className) {
            return;
        }

        if(targetElement.className.indexOf('fa-chevron-down') == -1 &&
           targetElement.className.indexOf('dropdown-toggle') == -1 &&
           targetElement.className.indexOf('calendar-dropdown-item') == -1) {
            const elements = document.getElementsByClassName('increase-z-index');
            if(elements && elements.length > 0) {
                for(let i = 0; i < elements.length; i++) {
                    elements[i].classList.remove('increase-z-index');
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/maintenance-calendar/maintenance-calendar-calendar-view/maintenance-calendar-calendar-view.component.ts